module.exports = __webpack_public_path__ + "img/ward_observer.18feb09e.png";